export default {
  add_rate: 'Tilføj sats',
  remove_rate: 'Fjern sats',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Enhver betalingsmetode',
    card: 'Kort',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Betal med bank',
    sepa_debit: 'SEPA-direkte debitering',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Bacs-direkte debitering',
    stripe_other: 'Andre Stripe-metoder',
  },
  fields: {
    percentage: 'Procent',
    fixed: 'Fast beløb',
    min: 'Minimumsbeløb',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Der opkræves endnu intet på {{method}} – disse betalinger giver 0 % margin, indtil der er angivet en sats.',
    floor_only: 'På {{method}} er betalingsgebyret {{floor}} på hver betaling, uanset ordrens samlede beløb.',
    percentage: 'På {{method}} er betalingsgebyret {{percentage}} % af ordrens samlede beløb.',
    percentage_floor:
      'På {{method}} er betalingsgebyret {{percentage}} % af ordrens samlede beløb og mindst {{floor}}.',
    fixed: 'På {{method}} er betalingsgebyret {{fixed}} pr. betaling.',
    fixed_floor: 'På {{method}} er betalingsgebyret {{fixed}} pr. betaling og mindst {{floor}}.',
    combined: 'På {{method}} er betalingsgebyret {{fixed}} fast plus {{percentage}} % af ordrens samlede beløb.',
    combined_floor:
      'På {{method}} er betalingsgebyret {{fixed}} fast plus {{percentage}} % af ordrens samlede beløb og mindst {{floor}}.',
    redundant_floor:
      'Minimumsbeløbet på {{floor}} træder aldrig i kraft – det faste beløb når allerede op på det ved hver betaling. Sæt det højere end {{fixed}}, eller fjern det.',
  },
  example: 'Eksempel: På en ordre på {{total}} er betalingsgebyret {{fee}}.',
};
